module.exports = __webpack_public_path__ + "static/media/hayden.936b5dec.jpeg";